export default {
	likedUsers: [],
	likedUsersLimit: 10,
	likedUsersOffset: 0,
	likedUsersFetchCompleted: false 
}